import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_rent_or_own_the_premises_they_occupy'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_rent_or_own_the_premises_they_occupy',
  name: 'Does the facility rent or own the premises they occupy?',
  description:
    'Facility may not own the land they occupy, but as long as they own the buildings that contain the facility operations/ productions select: Facility legally owns the premises/ buildings they occupy.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Facility legally owns the premises/ buildings they occupy.',
      key: 'FAC_LEGALLY_OWNS_THE_PREMISES_BUILDINGS_THEY_OCCUPY',
      slcpIndex: 1,
      slcpOptionName: 'facility-own',
    },
    {
      name: 'Facility does not legally own the buildings/ premises they occupy.',
      key: 'FAC_DOES_NOT_LEGALLY_OWN_THE_BUILDINGS_PREMISES_THEY_OCCUPY',
      slcpIndex: 2,
      slcpOptionName: 'facility-own',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: [
          'FAC_LEGALLY_OWNS_THE_PREMISES_BUILDINGS_THEY_OCCUPY',
          'FAC_DOES_NOT_LEGALLY_OWN_THE_BUILDINGS_PREMISES_THEY_OCCUPY',
        ],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-bui-13',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 1020,
  sectionId: '2.2.6.3',
  impactArea: 'Building and Operating Licenses',
  impactAreaId: 'BUILDING_AND_OPERATING_LICENSES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
